module.exports = __webpack_public_path__ + "media/images/icons/flags/LB-acfbe89b7ef8aca9d49f31c2bd5477af.svg";